import { Dispatch } from 'redux';

import T from '../actionTypes';
import { requestHandlers } from './showCaptcha';
import superagent from '../../../superagent';

const checkCaptcha = (token: string | null) => {
  return async (dispatch: Dispatch, getState: () => any) => {
    const {
      common: {
        limiter: { successUrl, keys },
      },
    } = getState();

    /**
     * В момент разрешения капчи массив хендлеров прерванных запросов
     * сортируется в порядке времени запросов (не ответов)
     */
    requestHandlers.sort((a, b) => a.reqTime - b.reqTime);

    try {
      await superagent.post(successUrl).send({
        keys,
        captchaResponse: token,
      });

      while (requestHandlers.length > 0) {
        requestHandlers.shift()!.resolve();
      }
    } catch (error) {
      while (requestHandlers.length > 0) {
        requestHandlers.shift()!.reject();
      }
    }

    dispatch({
      type: T.RESET_CAPTCHA,
    });
  };
};

export default checkCaptcha;
